export enum TrackingEventType {
	STUDY_PAGE_VIEW = 'study_view',
	ORGANISATION_PAGE_VIEW = 'organisation_view',
	REFERRAL_CLICK = 'referral_click',
	ADD_TO_WISHLIST = 'add_to_wishlist',
	ORGANISATION_PAGE_CLICK = 'organisation_page_click',
	REVIEWS_OPEN = 'reviews_open',
	BESTFIT_OPEN = 'bestfit_open'
}
